/**
 * Dates written in Arabic, by hand.
 *
 * Intl is not trustworthy for this. `ar-SA` renders a Hijri date in
 * Arabic-Indic digits, and the extensions that ask for neither —
 * `-u-ca-gregory-nu-latn` — are honoured by Node's full ICU and ignored by
 * iOS. So the test suite passed while the device printed ٥ سبتمبر، ٢٠٢٦ on a
 * certificate. Twelve month names cost less than a rule the runtime may
 * disregard, and this product writes Western digits everywhere.
 */

/** Gregorian months named in Arabic — the calendar this product dates by. */
export const MONTHS_AR = [
  'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
  'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
];

const two = (n: number): string => (n < 10 ? `0${n}` : String(n));

/** "5 سبتمبر 2026" — day, month name, year. */
export function arabicDay(date: Date): string {
  return `${date.getDate()} ${MONTHS_AR[date.getMonth()]} ${date.getFullYear()}`;
}

/** "5 سبتمبر 14:32" — the same day, with the clock, for a list of recordings. */
export function arabicDayTime(date: Date): string {
  return `${date.getDate()} ${MONTHS_AR[date.getMonth()]} ${two(date.getHours())}:${two(date.getMinutes())}`;
}
